module.exports = __webpack_public_path__ + "img/abc2eb8.jpg";